import React from 'react';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
export function ServicesPage() {
  return <main className="pt-24" data-id="element-473">
      <section className="bg-navy py-20 text-center relative overflow-hidden" data-id="element-474">
        <div className="absolute inset-0 z-0 opacity-20" data-id="element-475">
          <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80" alt="Data and growth analytics" className="w-full h-full object-cover" data-id="element-476" />
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-477">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-heading font-extrabold text-white mb-6" data-id="element-478">
            Our Services
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-479">
            Comprehensive local growth strategies to help your business dominate
            the map pack and turn customers into advocates.
          </motion.p>
        </div>
      </section>

      <Services data-id="element-480" />
      <Process data-id="element-481" />
      <CTASection data-id="element-482" />
    </main>;
}